import { useCallback, useState } from "react"
import PersonalInfo from "./perrsonal.info"
import ProfileUpload from "./profile.upload"
import { Alert } from "antd"
const ProfileInfo = () => {
    const [errorMessage, setErrorMessage] = useState(null)
    const handleError = useCallback((error) => {
        setErrorMessage(error)
    }, [])
    const closeError = useCallback(() => {
        setErrorMessage(null)
    }, [])
    return (
        <>
            {errorMessage &&
                <div className='mb-4'>
                    <Alert
                        className='mb-4'
                        type="error"
                        description={errorMessage}
                        showIcon
                        closable
                        onClose={closeError}
                    />
                </div>
            }
            <div className="md:flex block gap-7 items-start">
                <ProfileUpload handleError={handleError} />
                <PersonalInfo handleError={handleError} />
            </div>
        </>
    )
}
export default ProfileInfo